// extracted by mini-css-extract-plugin
module.exports = {"badge":"_3vYJ1MYJZRtwFT-_iFa24h","rowContainer":"_3mZF9v6hlQFJ0wly0NVJwp","icon":"_2tEJfOB4kDzLqpLxD3AJ3a"};